import { ApplicationStorage, AppStorageItemType } from "../ApplicationStorage";

/**
 * Třída představující hodnotu LocalizedText atributu
 */
export class LocalizedText {
    /**
     * Slovník překladů klíče do všech jazyků <kód jazyka, překlad>
     */
    public readonly translations: Readonly<Record<string, string>>;

    /**
     * Konstruktor
     * @param translations slovník s překlady
     */
    constructor(translations: Record<string, string>) {
        const translationsCopy: Record<string, string> = {};
        for (const key in translations) {
            translationsCopy[key] = translations[key];
        }
        this.translations = translationsCopy;
    }

    /**
     * Přetypování na string
     */
    public toString(): string {
        const language = ApplicationStorage.get(AppStorageItemType.language);
        if (language && Object.prototype.hasOwnProperty.call(this.translations, language as PropertyKey))
            return this.translations[language];
        return "";
    }
}
